import React, { InputHTMLAttributes } from "react";
import InputMask from 'react-input-mask';

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  mask: string;
  sizeClass?: string;
  fontClass?: string;
  rounded?: string;
  maskChar?: string;
}

// eslint-disable-next-line react/display-name
const InputMasked = React.forwardRef<HTMLInputElement, InputProps>(
  (
    {
      mask,
      className = "",
      sizeClass = "h-11 px-4 py-3",
      fontClass = "text-sm font-normal",
      rounded = "rounded-full",
      maskChar="_",
      children,
      type = "text",
      ...args
    },
    ref
  ) => {
    return (
      <InputMask
        mask={mask} // Define a máscara para CEP
        maskChar={maskChar} // Caractere a ser exibido nos espaços vazios
        type={type}
        className={`block w-full border-neutral-200 focus:border-primary-300 focus:ring focus:ring-primary-200/50 bg-white dark:border-neutral-500 dark:focus:ring-primary-500/30 dark:bg-neutral-900 ${rounded} ${fontClass} ${sizeClass} ${className}`}
        {...args}
      />
    );
  }
);

export default InputMasked;
